import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import vuetify from "@/plugins/vuetify";
import globalVar from "./utils/global_var";

import "vuetify/dist/vuetify.min.css";
import "./framework/index";
import "./scss/index.scss";

//  引用指令
import "./directives/index";
import "./setup/index";

Vue.prototype.GLOBAL = globalVar;
Vue.config.productionTip = false;


new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
